module.exports = __webpack_public_path__ + "assets/img/wechat_wenjuan_qrcode.9ccbc64e.jpg";